let installed = false
let lastTouchEnd = 0

function isInsideImageViewer(target) {
  return Boolean(target && target.closest && target.closest("[data-image-viewer]"))
}

function preventSafariGesture(event) {
  event.preventDefault()
}

function preventPageDoubleClick(event) {
  if (!isInsideImageViewer(event.target)) event.preventDefault()
}

function preventPageDoubleTap(event) {
  if (isInsideImageViewer(event.target) || event.touches && event.touches.length > 0) return
  const now = Date.now()
  if (now - lastTouchEnd > 0 && now - lastTouchEnd < 320) event.preventDefault()
  lastTouchEnd = now
}

export function installPwaGestureGuards() {
  if (installed || typeof document === "undefined") return
  installed = true
  document.addEventListener("gesturestart", preventSafariGesture, { passive: false })
  document.addEventListener("gesturechange", preventSafariGesture, { passive: false })
  document.addEventListener("gestureend", preventSafariGesture, { passive: false })
  document.addEventListener("dblclick", preventPageDoubleClick, { capture: true, passive: false })
  document.addEventListener("touchend", preventPageDoubleTap, { capture: true, passive: false })
}
